"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformEvent = void 0;
var AnalyticsProvider_1 = require("../AnalyticsProvider");
var RUDDER_STACK_KEY = "2Mjoq0cMO0K4AD8bQ46SxsMflyq";
var RUDDER_STACK_URL = "https://carsapandyezm.dataplane.rudderstack.com";
var RudderStack = /** @class */ (function (_super) {
    __extends(RudderStack, _super);
    function RudderStack() {
        var _this = _super.call(this, "rudder") || this;
        _this.ready = false;
        _this.queue = [];
        _this.identified = false;
        // @ts-ignore
        window.rudderanalytics = window.rudderanalytics = [];
        for (var methods = ["load", "page", "track", "identify", "alias", "group", "ready", "reset", "getAnonymousId", "setAnonymousId", "getUserId", "getUserTraits", "getGroupId", "getGroupTraits", "startSession", "endSession", "getSessionId"], i = 0; i < methods.length; i++) {
            var method = methods[i];
            // @ts-ignore
            window.rudderanalytics[method] = function (a) {
                return function () {
                    // @ts-ignore
                    window.rudderanalytics.push([a].concat(Array.prototype.slice.call(arguments)));
                };
            }(method);
        }
        // @ts-ignore
        window.rudderanalytics.load(RUDDER_STACK_KEY, RUDDER_STACK_URL);
        var asyncScript = document.createElement("script");
        asyncScript.async = true;
        asyncScript.src = "https://cdn.rudderlabs.com/beta/dmt/rudder-analytics.min.js";
        window.document.getElementsByTagName("head")[0].appendChild(asyncScript);
        // window.rudderanalytics.load(RUDDER_STACK_KEY, RUDDER_STACK_URL);
        // @ts-ignore
        window.rudderanalytics.ready(function () {
            _this.ready = true;
            var length = _this.queue.length;
            for (var i_1 = 0; i_1 < length; i_1++) {
                var event_1 = _this.queue.shift();
                if (event_1) {
                    _this.sendEvent(_this.dealUuid, event_1);
                }
            }
            return;
        });
        return _this;
    }
    RudderStack.prototype.sendEvent = function (dealUuid, event) {
        if (!this.ready) {
            this.dealUuid = dealUuid;
            this.queue.push(event);
            return;
        }
        if (!this.identified && dealUuid) {
            // @ts-ignore
            window.rudderanalytics.identify(dealUuid);
            this.identified = true;
        }
        else if (dealUuid !== this.dealUuid && dealUuid) {
            // @ts-ignore
            window.rudderanalytics.alias(dealUuid);
            this.dealUuid = dealUuid;
        }
        var name = event.name, properties = __rest(event, ["name"]);
        // @ts-ignore
        window.rudderanalytics.track(name, __assign({}, properties));
    };
    RudderStack.prototype.createEvent = function (name, dealUuid, vehicle) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        return {
            name: name,
            deal_uuid: dealUuid,
            // @ts-ignore
            page_type: (_b = (_a = window === null || window === void 0 ? void 0 : window.asc_datalayer) === null || _a === void 0 ? void 0 : _a.page_type) !== null && _b !== void 0 ? _b : "unknown",
            vin: vehicle.vin,
            stock: (_c = vehicle.stock) !== null && _c !== void 0 ? _c : "",
            payment_type: (_e = (_d = vehicle === null || vehicle === void 0 ? void 0 : vehicle.payments) === null || _d === void 0 ? void 0 : _d.selected) !== null && _e !== void 0 ? _e : "cash",
            price: (_l = (_k = (_j = (_f = vehicle === null || vehicle === void 0 ? void 0 : vehicle.payments) === null || _f === void 0 ? void 0 : _f[(_h = (_g = vehicle === null || vehicle === void 0 ? void 0 : vehicle.payments) === null || _g === void 0 ? void 0 : _g.selected) !== null && _h !== void 0 ? _h : "cash"]) === null || _j === void 0 ? void 0 : _j.price) !== null && _k !== void 0 ? _k : vehicle.msrp) !== null && _l !== void 0 ? _l : "",
            type: vehicle.type,
            year: vehicle.year,
            make: vehicle.make,
            model: vehicle.model,
            trim: (_m = vehicle.trim) !== null && _m !== void 0 ? _m : "",
            body_type: (_o = vehicle.bodytype) !== null && _o !== void 0 ? _o : ""
        };
    };
    RudderStack.prototype.opened = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Opened", dealUuid, vehicle));
    };
    RudderStack.prototype.closed = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Closed", dealUuid, vehicle));
    };
    RudderStack.prototype.dealCreated = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Deal Created", dealUuid, vehicle));
    };
    RudderStack.prototype.vehicleAdded = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Vehicle Added", dealUuid, vehicle));
    };
    RudderStack.prototype.vehicleRemoved = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Vehicle Removed", dealUuid, vehicle));
    };
    /**
     * Lead form events
     */
    RudderStack.prototype.leadFormViewed = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Lead Form Viewed", dealUuid, vehicle));
    };
    RudderStack.prototype.leadFormStarted = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Lead Form Started", dealUuid, vehicle));
    };
    RudderStack.prototype.leadFormFinished = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Lead Form Finished", dealUuid, vehicle));
    };
    /**
     * Payment Calculator Events
     */
    RudderStack.prototype.paymentCalcViewed = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Payment Calculator Viewed", dealUuid, vehicle));
    };
    RudderStack.prototype.paymentCalcInteraction = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Payment Calculator Interaction", dealUuid, vehicle));
    };
    RudderStack.prototype.paymentCalcFinished = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Payment Calculator Finished", dealUuid, vehicle));
    };
    /**
     * Garage Events
     */
    RudderStack.prototype.garageInteraction = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Garage Interaction", dealUuid, vehicle));
    };
    /**
     * Test Drive Events
     */
    RudderStack.prototype.testDriveFormViewed = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Test Drive Form Viewed", dealUuid, vehicle));
    };
    RudderStack.prototype.testDriveFormStarted = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Test Drive Form Started", dealUuid, vehicle));
    };
    RudderStack.prototype.testDriveFormFinished = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Test Drive Form Finished", dealUuid, vehicle));
    };
    /**
     * Reserve Vehicle Events
     */
    RudderStack.prototype.reserveVehicleFormViewed = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Reserve Vehicle Form Viewed", dealUuid, vehicle));
    };
    RudderStack.prototype.reserveVehicleFormStarted = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Reserve Vehicle Form Started", dealUuid, vehicle));
    };
    RudderStack.prototype.reserveVehicleFormFinished = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Reserve Vehicle Form Finished", dealUuid, vehicle));
    };
    /**
     * Upgrade events
     */
    RudderStack.prototype.upgradesViewed = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Upgrades Viewed", dealUuid, vehicle));
    };
    RudderStack.prototype.upgradeAdded = function (id, dealUuid, vehicle, addOnName) {
        this.sendEvent(dealUuid, this.createEvent("Upgrade Added", dealUuid, vehicle));
    };
    RudderStack.prototype.upgradesFinished = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Upgrades Finished", dealUuid, vehicle));
    };
    RudderStack.prototype.menuingViewed = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Menuing Viewed", dealUuid, vehicle));
    };
    RudderStack.prototype.ancillaryProductAdded = function (dealUuid, vehicle, productName) {
        this.sendEvent(dealUuid, this.createEvent("Ancillary Product Added", dealUuid, vehicle));
    };
    RudderStack.prototype.menuingFinished = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Menuing Finished", dealUuid, vehicle));
    };
    /**
     * Trade In Events
     */
    RudderStack.prototype.tradeInFormViewed = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Trade In Viewed", dealUuid, vehicle));
    };
    RudderStack.prototype.tradeInFormStarted = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Trade In Started", dealUuid, vehicle));
    };
    RudderStack.prototype.tradeInFormFinished = function (dealUuid, vehicle, programParticipation) {
        this.sendEvent(dealUuid, this.createEvent("Trade In Finished", dealUuid, vehicle));
    };
    /**
     * Soft Credit Pull
     */
    RudderStack.prototype.softCreditFormViewed = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Soft Credit Form Viewed", dealUuid, vehicle));
    };
    RudderStack.prototype.softCreditFormStarted = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Soft Credit Form Started", dealUuid, vehicle));
    };
    RudderStack.prototype.softCreditFormFinished = function (dealUuid, vehicle, applicationId) {
        this.sendEvent(dealUuid, this.createEvent("Soft Credit Form Finished", dealUuid, vehicle));
    };
    /**
     * Hard Credit Pull
     */
    RudderStack.prototype.hardCreditFormViewed = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Hard Credit Form Viewed", dealUuid, vehicle));
    };
    RudderStack.prototype.hardCreditFormStarted = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Hard Credit Form Started", dealUuid, vehicle));
    };
    RudderStack.prototype.hardCreditFormFinished = function (dealUuid, vehicle, applicationId) {
        this.sendEvent(dealUuid, this.createEvent("Hard Credit Form Finished", dealUuid, vehicle));
    };
    /**
     * Schedule Pickup / Delivery form
     */
    RudderStack.prototype.schedulePickupOrDeliveryFormViewed = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Schedule Pickup Or Delivery Form Viewed", dealUuid, vehicle));
    };
    RudderStack.prototype.schedulePickupOrDeliveryFormStarted = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Schedule Pickup Or Delivery Form Started", dealUuid, vehicle));
    };
    RudderStack.prototype.schedulePickupOrDeliveryFormFinished = function (dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Schedule Pickup Or Delivery Form Finished", dealUuid, vehicle));
    };
    RudderStack.prototype.continueDeal = function (vin, dealUuid, vehicle) {
        this.sendEvent(dealUuid, this.createEvent("Continue Deal", dealUuid, vehicle));
    };
    return RudderStack;
}(AnalyticsProvider_1.AnalyticsProvider));
// Copy and Paste to RudderStack.... and then remove types. Gross
function transformEvent(event, metadata) {
    var createGA4RetailProcessEvent = function (event, flowName) {
        var _a, _b;
        var flowOutcome;
        switch (flowName) {
            case "contact_info":
            case "credit_app":
            case "delivery":
            case "test_drive":
                flowOutcome = "lead";
                break;
            case "trade":
            case "payment_calculator":
            case "accessories":
            case "finalize_deal":
            case "soft_pull":
            case "compare":
            case "service_plans":
                flowOutcome = "proceed";
                break;
        }
        var flowStage;
        switch (flowName) {
            case "contact_info":
                flowStage = 3;
                break;
            case "test_drive":
                flowStage = 5;
                break;
            case "credit_app":
                flowStage = 10;
                break;
            case "delivery":
                flowStage = 11;
                break;
            case "trade":
                flowStage = 3;
                break;
            case "payment_calculator":
                flowStage = 0;
                break;
            case "accessories":
                flowStage = 6;
                break;
            case "finalize_deal":
                flowStage = 9;
                break;
            case "soft_pull":
                flowStage = 8;
                break;
            case "compare":
                flowStage = 4; // We don't have a Garage Viewed event yet. TODO
                break;
            case "service_plans":
                flowStage = 7;
                break;
        }
        return {
            event_name: "asc_retail_process",
            event_owner: "online_shopper",
            // @ts-ignore
            page_type: (_b = (_a = window === null || window === void 0 ? void 0 : window.asc_datalayer) === null || _a === void 0 ? void 0 : _a.page_type) !== null && _b !== void 0 ? _b : "unknown",
            flow_name: flowName,
            element_title: "",
            flow_outcome: flowOutcome,
            item_payment: event.payment_type,
            flow_stage: flowStage,
            item_id: event.vin,
            item_number: event.stock,
            item_price: event.price,
            item_condition: event.type,
            item_year: event.year,
            item_make: event.make,
            item_model: event.model,
            item_variant: event.trim,
            item_color: "",
            item_type: event.body_type,
            item_category: "",
            item_fuel_type: "",
            item_inventory_date: "",
            send_to: ["G-ZQMCC9TNWY", "G-RL4SNHHWF7"] // Test values
        };
    };
    var createGA4FormSubmissionEvent = function (event, formType) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (formType === "delivery" || formType === "test_drive") {
            return [{
                    event_name: "asc_form_submission",
                    event_owner: "online_shopper",
                    // @ts-ignore
                    page_type: (_b = (_a = window === null || window === void 0 ? void 0 : window.asc_datalayer) === null || _a === void 0 ? void 0 : _a.page_type) !== null && _b !== void 0 ? _b : "unknown",
                    comm_type: "form",
                    comm_outcome: "",
                    submission_id: event.deal_uuid,
                    form_name: "online_shopper",
                    form_type: formType,
                    department: "sales",
                    element_text: "",
                    item_payment: event.payment_type,
                    item_id: event.vin,
                    item_number: event.stock,
                    item_price: event.price,
                    item_condition: event.type,
                    item_year: event.year,
                    item_make: event.make,
                    item_model: event.model,
                    item_variant: event.trim,
                    item_color: "",
                    item_type: event.body_type,
                    item_category: "",
                    item_fuel_type: "",
                    item_inventory_date: "",
                    send_to: ["G-ZQMCC9TNWY", "G-RL4SNHHWF7"] // Test values
                }, {
                    event_name: "asc_form_submission_sales_appt",
                    event_owner: "online_shopper",
                    // @ts-ignore
                    page_type: (_d = (_c = window === null || window === void 0 ? void 0 : window.asc_datalayer) === null || _c === void 0 ? void 0 : _c.page_type) !== null && _d !== void 0 ? _d : "unknown",
                    comm_type: "form",
                    comm_outcome: "",
                    submission_id: event.deal_uuid,
                    form_name: "online_shopper",
                    form_type: formType,
                    department: "sales",
                    element_text: "",
                    item_payment: event.payment_type,
                    item_id: event.vin,
                    item_number: event.stock,
                    item_price: event.price,
                    item_condition: event.type,
                    item_year: event.year,
                    item_make: event.make,
                    item_model: event.model,
                    item_variant: event.trim,
                    item_color: "",
                    item_type: event.body_type,
                    item_category: "",
                    item_fuel_type: "",
                    item_inventory_date: "",
                    send_to: ["G-ZQMCC9TNWY", "G-RL4SNHHWF7"] // Test values
                }];
        }
        return [{
                event_name: "asc_form_submission",
                event_owner: "online_shopper",
                // @ts-ignore
                page_type: (_f = (_e = window === null || window === void 0 ? void 0 : window.asc_datalayer) === null || _e === void 0 ? void 0 : _e.page_type) !== null && _f !== void 0 ? _f : "unknown",
                comm_type: "form",
                comm_outcome: "",
                submission_id: event.deal_uuid,
                form_name: "online_shopper",
                form_type: formType,
                department: "sales",
                element_text: "",
                item_payment: event.payment_type,
                item_id: event.vin,
                item_number: event.stock,
                item_price: event.price,
                item_condition: event.type,
                item_year: event.year,
                item_make: event.make,
                item_model: event.model,
                item_variant: event.trim,
                item_color: "",
                item_type: event.body_type,
                item_category: "",
                item_fuel_type: "",
                item_inventory_date: "",
                send_to: ["G-ZQMCC9TNWY", "G-RL4SNHHWF7"] // Test values
            }, {
                event_name: "asc_form_submission_sales",
                event_owner: "online_shopper",
                // @ts-ignore
                page_type: (_h = (_g = window === null || window === void 0 ? void 0 : window.asc_datalayer) === null || _g === void 0 ? void 0 : _g.page_type) !== null && _h !== void 0 ? _h : "unknown",
                comm_type: "form",
                comm_outcome: "",
                submission_id: event.deal_uuid,
                form_name: "online_shopper",
                form_type: formType,
                department: "sales",
                element_text: "",
                item_payment: event.payment_type,
                item_id: event.vin,
                item_number: event.stock,
                item_price: event.price,
                item_condition: event.type,
                item_year: event.year,
                item_make: event.make,
                item_model: event.model,
                item_variant: event.trim,
                item_color: "",
                item_type: event.body_type,
                item_category: "",
                item_fuel_type: "",
                item_inventory_date: "",
                send_to: ["G-ZQMCC9TNWY", "G-RL4SNHHWF7"] // Test values
            }];
    };
    switch (event.name) {
        case "Opened":
            return;
        case "Closed":
            return;
        case "Deal Created":
            return;
        case "Vehicle Added":
            return;
        case "Vehicle Removed":
            return;
        case "Lead Form Viewed":
            return createGA4RetailProcessEvent(event, "contact_info");
        case "Lead Form Started":
            return;
        case "Lead Form Finished":
            return createGA4FormSubmissionEvent(event, "contact_info");
        case "Payment Calculator Viewed":
            return createGA4RetailProcessEvent(event, "payment_calculator");
        case "Payment Calculator Interaction":
            return;
        case "Payment Calculator Finished":
            return createGA4FormSubmissionEvent(event, "payment_calculator");
        case "Garage Interaction":
            return;
        case "Test Drive Form Viewed":
            return createGA4RetailProcessEvent(event, "test_drive");
        case "Test Drive Form Started":
            return;
        case "Test Drive Form Finished":
            return createGA4FormSubmissionEvent(event, "test_drive");
        case "Reserve Vehicle Form Viewed":
            return createGA4RetailProcessEvent(event, "reserve_vehicle");
        case "Reserve Vehicle Form Started":
            return;
        case "Reserve Vehicle Form Finished":
            return createGA4FormSubmissionEvent(event, "reserve_vehicle");
        case "Upgrades Viewed":
            return createGA4RetailProcessEvent(event, "accessories");
        case "Upgrades Finished":
            return createGA4FormSubmissionEvent(event, "accessories");
        case "Menuing Viewed":
            return createGA4RetailProcessEvent(event, "service_plans");
        case "Menuing Finished":
            return createGA4FormSubmissionEvent(event, "service_plans");
        case "Trade In Viewed":
            return createGA4RetailProcessEvent(event, "trade");
        case "Trade In Started":
            return;
        case "Trade In Finished":
            return createGA4FormSubmissionEvent(event, "trade");
        case "Soft Credit Form Viewed":
            return createGA4RetailProcessEvent(event, "soft_pull");
        case "Soft Credit Form Started":
            return;
        case "Soft Credit Form Finished":
            return createGA4FormSubmissionEvent(event, "soft_pull");
        case "Hard Credit Form Viewed":
            return createGA4RetailProcessEvent(event, "credit_app");
        case "Hard Credit Form Started":
            return;
        case "Hard Credit Form Finished":
            return createGA4FormSubmissionEvent(event, "credit_app");
        case "Schedule Pickup Or Delivery Form Viewed":
            return createGA4RetailProcessEvent(event, "delivery");
        case "Schedule Pickup Or Delivery Form Started":
            return;
        case "Schedule Pickup Or Delivery Form Finished":
            return createGA4FormSubmissionEvent(event, "delivery");
        case "Continue Deal":
            return createGA4RetailProcessEvent(event, "finalize_deal");
    }
}
exports.transformEvent = transformEvent;
exports.default = RudderStack;
